import React from 'react';
import { BRAND_LOGO_SRC, BRAND_NAME } from '../../assets/brand';

const HeaderLogo = ({ topToPage }) => (
  <div className="logo" onClick={(e) => topToPage(e)}>
    <img
      src={BRAND_LOGO_SRC}
      alt={BRAND_NAME}
      onClick={(e) => topToPage(e)}
    />
  </div>
);

export default HeaderLogo;
